// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   Exercise Feedback – Coach View (Messaging-App Layout)
   Left sidebar = player list  |  Right panel = conversation
   ================================================================ */

.fb-page {
    max-width: 960px;
    margin: 0 auto;
    padding: 8px 12px 0;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
    overflow: hidden;
}

/* ── Compact Exercise Info Bar ──────────────────────── */
.fb-exercise-bar {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #fff;
    border-radius: 14px;
    padding: 10px 16px;
    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.08);
    margin-bottom: 8px;
    flex-shrink: 0;
}

.fb-exercise-bar__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
    color: var(--brand-primary);
}

.fb-exercise-bar__info {
    flex: 1 1;
    min-width: 0;
}

.fb-exercise-bar__name {
    font-size: 14px;
    font-weight: 700;
    color: #1a2b3c;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fb-exercise-bar__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
    flex-wrap: wrap;
}

.fb-exercise-bar__tag {
    font-size: 10px;
    font-weight: 600;
    color: var(--brand-primary);
    background: rgba(var(--brand-primary-rgb), 0.08);
    padding: 2px 7px;
    border-radius: 6px;
    white-space: nowrap;
}

.fb-exercise-bar__objective {
    font-size: 10px;
    color: #78909c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ================================================================
   Two-Panel Messaging Layout
   ================================================================ */
.fb-body {
    flex: 1 1;
    display: flex;
    gap: 0;
    min-height: 0;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.06);
    overflow: hidden;
}

/* ── Left Sidebar: Player List ─────────────────────── */
.fb-sidebar {
    width: 220px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eef2f6;
    background: #fafbfc;
}

.fb-sidebar__header {
    padding: 12px 14px 8px;
    font-size: 11px;
    font-weight: 700;
    color: #90a4ae;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    flex-shrink: 0;
}

.fb-sidebar__list {
    flex: 1 1;
    overflow-y: auto;
    padding: 0 6px 8px;
}

.fb-sidebar__list::-webkit-scrollbar {
    width: 3px;
}

.fb-sidebar__list::-webkit-scrollbar-thumb {
    background: #d6dde4;
    border-radius: 3px;
}

/* ── Player Row ────────────────────────────────────── */
.fb-player-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s ease;
    -webkit-user-select: none;
            user-select: none;
    margin-bottom: 2px;
}

.fb-player-row:hover {
    background: #eef4f9;
}

.fb-player-row--active {
    background: var(--brand-primary);
    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb), 0.25);
}

.fb-player-row--active:hover {
    background: var(--brand-primary-dark, #065a8f);
}

.fb-player-row__avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: var(--brand-primary);
}

.fb-player-row--active .fb-player-row__avatar {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
}

.fb-player-row__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.fb-player-row__info {
    flex: 1 1;
    min-width: 0;
}

.fb-player-row__name {
    font-size: 13px;
    font-weight: 600;
    color: #1a2b3c;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fb-player-row--active .fb-player-row__name {
    color: #fff;
}

.fb-player-row__sub {
    font-size: 10px;
    color: #90a4ae;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.fb-player-row--active .fb-player-row__sub {
    color: rgba(255, 255, 255, 0.7);
}

/* "All" row icon */
.fb-player-row__all-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
    background: linear-gradient(135deg, var(--brand-primary) 0%, #0a9be0 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    color: #fff;
}

.fb-player-row--active .fb-player-row__all-icon {
    background: rgba(255, 255, 255, 0.2);
}

/* ── Right Panel: Conversation ─────────────────────── */
.fb-conversation {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: #f6f8fa;
}

/* Conversation header (shows who you're chatting with) */
.fb-conv-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: #fff;
    border-bottom: 1px solid #eef2f6;
    flex-shrink: 0;
}

.fb-conv-header__back {
    display: none;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    color: var(--brand-primary);
    font-size: 20px;
    flex-shrink: 0;
}

.fb-conv-header__back:hover {
    background: #f0f4f8;
}

.fb-conv-header__avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: var(--brand-primary);
}

.fb-conv-header__avatar--all {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #0a9be0 100%);
    color: #fff;
    font-size: 15px;
}

.fb-conv-header__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.fb-conv-header__name {
    font-size: 14px;
    font-weight: 700;
    color: #1a2b3c;
    margin: 0;
}

.fb-conv-header__label {
    font-size: 10px;
    color: #90a4ae;
    margin: 0;
}

/* ── Auto-Evaluation Summary (inline in conversation) ── */
.fb-eval-strip {
    display: flex;
    gap: 8px;
    padding: 8px 14px;
    flex-shrink: 0;
    background: #fff;
    border-bottom: 1px solid #eef2f6;
}

.fb-eval-card {
    flex: 1 1;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8fafb;
    border-radius: 10px;
    padding: 8px 12px;
}

.fb-eval-card__emoji {
    font-size: 24px;
    flex-shrink: 0;
    line-height: 1;
}

.fb-eval-card__content {
    min-width: 0;
}

.fb-eval-card__label {
    font-size: 9px;
    font-weight: 700;
    color: #90a4ae;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
}

.fb-eval-card__value {
    font-size: 12px;
    font-weight: 600;
    color: #37474f;
    margin: 0;
}

/* ── Chat Messages Area ────────────────────────────── */
.fb-chat {
    flex: 1 1;
    overflow-y: auto;
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    scroll-behavior: smooth;
    min-height: 0;
}

.fb-chat::-webkit-scrollbar {
    width: 4px;
}

.fb-chat::-webkit-scrollbar-thumb {
    background: #cfd8dc;
    border-radius: 4px;
}

.fb-chat__empty {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #b0bec5;
    padding: 40px 20px;
    text-align: center;
}

.fb-chat__empty-icon {
    font-size: 36px;
    opacity: 0.4;
}

.fb-chat__empty-text {
    font-size: 13px;
    font-weight: 500;
}

/* ── Message Bubble ────────────────────────────────── */
.fb-msg {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    max-width: 78%;
    animation: fbMsgIn 0.2s ease;
}

@keyframes fbMsgIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
}

.fb-msg--mine {
    align-self: flex-end;
    flex-direction: row-reverse;
}

.fb-msg--theirs {
    align-self: flex-start;
}

.fb-msg__avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: var(--brand-primary);
}

.fb-msg__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.fb-msg__bubble {
    padding: 9px 13px;
    border-radius: 16px;
    font-size: 13px;
    line-height: 1.45;
    word-break: break-word;
}

.fb-msg--mine .fb-msg__bubble {
    background: var(--brand-primary);
    color: #fff;
    border-bottom-right-radius: 4px;
}

.fb-msg--theirs .fb-msg__bubble {
    background: #fff;
    color: #1a2b3c;
    border-bottom-left-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.fb-msg__audio {
    min-width: 180px;
}

.fb-msg__audio audio {
    width: 100%;
    height: 34px;
    border-radius: 17px;
}

.fb-msg__video video {
    max-width: 240px;
    max-height: 180px;
    border-radius: 12px;
    display: block;
}

.fb-msg__video--evaluation .fb-msg__eval-label {
    margin: 0 0 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #5c6bc0;
}

.fb-msg__video--evaluation .fb-msg__eval-caption {
    margin: 6px 0 0;
    font-size: 12px;
    color: #607d8b;
    line-height: 1.35;
}

/* Session timeline: group messages by training exercise */
.fb-chat__group-label {
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 10px 4px 6px;
    margin: 6px 0 2px;
}

.fb-chat__group-label__text {
    font-size: 11px;
    font-weight: 600;
    color: #90a4ae;
    text-align: center;
}

.fb-chat__group-label__order {
    font-weight: 500;
    color: #b0bec5;
}

.fb-chat__group-label__badge {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--brand-primary);
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
    padding: 3px 8px;
    border-radius: 999px;
}

.fb-chat__group-label--current .fb-chat__group-label__text {
    color: var(--brand-primary);
}

.fb-msg--current-ex.fb-msg--theirs .fb-msg__bubble {
    box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
    background: #f3f9ff;
}

.fb-msg--current-ex.fb-msg--mine .fb-msg__bubble {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.55);
}

/* ── Composer (Input Area) ─────────────────────────── */
.fb-composer {
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #eef2f6;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.fb-composer__input {
    flex: 1 1;
    border: none;
    outline: none;
    font-size: 13px;
    font-family: var(--brand-font);
    padding: 9px 14px;
    border-radius: 22px;
    background: #f4f6f8;
    color: #1a2b3c;
    transition: background 0.2s;
}

.fb-composer__input::placeholder {
    color: #b0bec5;
}

.fb-composer__input:focus {
    background: #eceff1;
}

.fb-composer__actions {
    display: flex;
    align-items: center;
    gap: 2px;
}

.fb-composer__btn {
    width: 38px;
    height: 38px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: transparent;
    color: #78909c;
    font-size: 19px;
}

.fb-composer__btn:hover {
    background: #f0f4f8;
    color: var(--brand-primary);
}

.fb-composer__btn--send {
    background: var(--brand-primary);
    color: #fff;
    width: 40px;
    height: 40px;
}

.fb-composer__btn--send:hover {
    background: var(--brand-primary-dark);
    color: #fff;
}

.fb-composer__btn--send svg {
    font-size: 17px;
}

.fb-composer__video-label {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: transparent;
    color: #78909c;
    font-size: 17px;
}

.fb-composer__video-label:hover {
    background: #f0f4f8;
    color: var(--brand-primary);
}

/* AudioRecorder overrides */
.fb-composer .audio-recorder {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    height: 38px !important;
}

.fb-composer .audio-recorder-mic {
    color: #78909c !important;
    transition: color 0.2s !important;
}

.fb-composer .audio-recorder-mic:hover {
    color: var(--brand-primary) !important;
}

/* ================================================================
   Responsive: Mobile (<640px) – full-screen toggle
   ================================================================ */
@media (max-width: 640px) {
    .fb-page {
        padding: 6px 6px 0;
    }

    .fb-body {
        border-radius: 10px;
    }

    /* Sidebar fills the whole panel on mobile */
    .fb-sidebar {
        width: 100%;
        border-right: none;
    }

    /* When a conversation is open, hide sidebar */
    .fb-body--chat-open .fb-sidebar {
        display: none;
    }

    /* When no conversation, hide chat panel */
    .fb-body:not(.fb-body--chat-open) .fb-conversation {
        display: none;
    }

    /* Show back button on mobile */
    .fb-conv-header__back {
        display: flex;
    }

    .fb-exercise-bar {
        padding: 8px 12px;
        gap: 10px;
    }

    .fb-exercise-bar__name {
        font-size: 13px;
    }

    .fb-exercise-bar__icon {
        width: 34px;
        height: 34px;
        font-size: 17px;
    }

    .fb-msg {
        max-width: 88%;
    }

    .fb-eval-strip {
        flex-direction: column;
        gap: 6px;
        padding: 8px 10px;
    }
}

/* ── Tablet tweaks ─────────────────────────────────── */
@media (min-width: 641px) and (max-width: 800px) {
    .fb-sidebar {
        width: 180px;
    }

    .fb-player-row__avatar,
    .fb-player-row__all-icon {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    .fb-player-row__name {
        font-size: 12px;
    }

    .fb-player-row {
        padding: 7px 8px;
        gap: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/coach/ExerciseFeedback.css"],"names":[],"mappings":"AAAA;;;qEAGqE;;AAErE;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gDAAgD;IAChD,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;qEAEqE;AACrE;IACI,SAAO;IACP,aAAa;IACb,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,0DAA0D;AAC9D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,0EAA0E;IAC1E,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA,yDAAyD;AACzD;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,0EAA0E;IAC1E,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,yDAAyD;AACzD;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA,0DAA0D;AAC1D;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,6DAA6D;IAC7D,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uEAAuE;IACvE,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;AACnD;;AAEA,yDAAyD;AACzD;IACI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,4BAA4B;AAC5B;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;qEAEqE;AACrE;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA,4CAA4C;IAC5C;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA,8CAA8C;IAC9C;QACI,aAAa;IACjB;;IAEA,0CAA0C;IAC1C;QACI,aAAa;IACjB;;IAEA,+BAA+B;IAC/B;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,iBAAiB;IACrB;AACJ;;AAEA,yDAAyD;AACzD;IACI;QACI,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,QAAQ;IACZ;AACJ","sourcesContent":["/* ================================================================\n   Exercise Feedback – Coach View (Messaging-App Layout)\n   Left sidebar = player list  |  Right panel = conversation\n   ================================================================ */\n\n.fb-page {\n    max-width: 960px;\n    margin: 0 auto;\n    padding: 8px 12px 0;\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 60px);\n    overflow: hidden;\n}\n\n/* ── Compact Exercise Info Bar ──────────────────────── */\n.fb-exercise-bar {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    background: #fff;\n    border-radius: 14px;\n    padding: 10px 16px;\n    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.08);\n    margin-bottom: 8px;\n    flex-shrink: 0;\n}\n\n.fb-exercise-bar__icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 20px;\n    color: var(--brand-primary);\n}\n\n.fb-exercise-bar__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.fb-exercise-bar__name {\n    font-size: 14px;\n    font-weight: 700;\n    color: #1a2b3c;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fb-exercise-bar__meta {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 2px;\n    flex-wrap: wrap;\n}\n\n.fb-exercise-bar__tag {\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    background: rgba(var(--brand-primary-rgb), 0.08);\n    padding: 2px 7px;\n    border-radius: 6px;\n    white-space: nowrap;\n}\n\n.fb-exercise-bar__objective {\n    font-size: 10px;\n    color: #78909c;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ================================================================\n   Two-Panel Messaging Layout\n   ================================================================ */\n.fb-body {\n    flex: 1;\n    display: flex;\n    gap: 0;\n    min-height: 0;\n    background: #fff;\n    border-radius: 14px;\n    box-shadow: 0 1px 8px rgba(8, 119, 188, 0.06);\n    overflow: hidden;\n}\n\n/* ── Left Sidebar: Player List ─────────────────────── */\n.fb-sidebar {\n    width: 220px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid #eef2f6;\n    background: #fafbfc;\n}\n\n.fb-sidebar__header {\n    padding: 12px 14px 8px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #90a4ae;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    flex-shrink: 0;\n}\n\n.fb-sidebar__list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 6px 8px;\n}\n\n.fb-sidebar__list::-webkit-scrollbar {\n    width: 3px;\n}\n\n.fb-sidebar__list::-webkit-scrollbar-thumb {\n    background: #d6dde4;\n    border-radius: 3px;\n}\n\n/* ── Player Row ────────────────────────────────────── */\n.fb-player-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    user-select: none;\n    margin-bottom: 2px;\n}\n\n.fb-player-row:hover {\n    background: #eef4f9;\n}\n\n.fb-player-row--active {\n    background: var(--brand-primary);\n    box-shadow: 0 2px 8px rgba(var(--brand-primary-rgb), 0.25);\n}\n\n.fb-player-row--active:hover {\n    background: var(--brand-primary-dark, #065a8f);\n}\n\n.fb-player-row__avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #e3f2fd;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--brand-primary);\n}\n\n.fb-player-row--active .fb-player-row__avatar {\n    background: rgba(255, 255, 255, 0.2);\n    color: #fff;\n}\n\n.fb-player-row__avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.fb-player-row__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.fb-player-row__name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a2b3c;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fb-player-row--active .fb-player-row__name {\n    color: #fff;\n}\n\n.fb-player-row__sub {\n    font-size: 10px;\n    color: #90a4ae;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.fb-player-row--active .fb-player-row__sub {\n    color: rgba(255, 255, 255, 0.7);\n}\n\n/* \"All\" row icon */\n.fb-player-row__all-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #0a9be0 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 17px;\n    color: #fff;\n}\n\n.fb-player-row--active .fb-player-row__all-icon {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n/* ── Right Panel: Conversation ─────────────────────── */\n.fb-conversation {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    background: #f6f8fa;\n}\n\n/* Conversation header (shows who you're chatting with) */\n.fb-conv-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    background: #fff;\n    border-bottom: 1px solid #eef2f6;\n    flex-shrink: 0;\n}\n\n.fb-conv-header__back {\n    display: none;\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    color: var(--brand-primary);\n    font-size: 20px;\n    flex-shrink: 0;\n}\n\n.fb-conv-header__back:hover {\n    background: #f0f4f8;\n}\n\n.fb-conv-header__avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #e3f2fd;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--brand-primary);\n}\n\n.fb-conv-header__avatar--all {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #0a9be0 100%);\n    color: #fff;\n    font-size: 15px;\n}\n\n.fb-conv-header__avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.fb-conv-header__name {\n    font-size: 14px;\n    font-weight: 700;\n    color: #1a2b3c;\n    margin: 0;\n}\n\n.fb-conv-header__label {\n    font-size: 10px;\n    color: #90a4ae;\n    margin: 0;\n}\n\n/* ── Auto-Evaluation Summary (inline in conversation) ── */\n.fb-eval-strip {\n    display: flex;\n    gap: 8px;\n    padding: 8px 14px;\n    flex-shrink: 0;\n    background: #fff;\n    border-bottom: 1px solid #eef2f6;\n}\n\n.fb-eval-card {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: #f8fafb;\n    border-radius: 10px;\n    padding: 8px 12px;\n}\n\n.fb-eval-card__emoji {\n    font-size: 24px;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n.fb-eval-card__content {\n    min-width: 0;\n}\n\n.fb-eval-card__label {\n    font-size: 9px;\n    font-weight: 700;\n    color: #90a4ae;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin: 0;\n}\n\n.fb-eval-card__value {\n    font-size: 12px;\n    font-weight: 600;\n    color: #37474f;\n    margin: 0;\n}\n\n/* ── Chat Messages Area ────────────────────────────── */\n.fb-chat {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    scroll-behavior: smooth;\n    min-height: 0;\n}\n\n.fb-chat::-webkit-scrollbar {\n    width: 4px;\n}\n\n.fb-chat::-webkit-scrollbar-thumb {\n    background: #cfd8dc;\n    border-radius: 4px;\n}\n\n.fb-chat__empty {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: #b0bec5;\n    padding: 40px 20px;\n    text-align: center;\n}\n\n.fb-chat__empty-icon {\n    font-size: 36px;\n    opacity: 0.4;\n}\n\n.fb-chat__empty-text {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* ── Message Bubble ────────────────────────────────── */\n.fb-msg {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n    max-width: 78%;\n    animation: fbMsgIn 0.2s ease;\n}\n\n@keyframes fbMsgIn {\n    from { opacity: 0; transform: translateY(6px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.fb-msg--mine {\n    align-self: flex-end;\n    flex-direction: row-reverse;\n}\n\n.fb-msg--theirs {\n    align-self: flex-start;\n}\n\n.fb-msg__avatar {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #e3f2fd;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--brand-primary);\n}\n\n.fb-msg__avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.fb-msg__bubble {\n    padding: 9px 13px;\n    border-radius: 16px;\n    font-size: 13px;\n    line-height: 1.45;\n    word-break: break-word;\n}\n\n.fb-msg--mine .fb-msg__bubble {\n    background: var(--brand-primary);\n    color: #fff;\n    border-bottom-right-radius: 4px;\n}\n\n.fb-msg--theirs .fb-msg__bubble {\n    background: #fff;\n    color: #1a2b3c;\n    border-bottom-left-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.fb-msg__audio {\n    min-width: 180px;\n}\n\n.fb-msg__audio audio {\n    width: 100%;\n    height: 34px;\n    border-radius: 17px;\n}\n\n.fb-msg__video video {\n    max-width: 240px;\n    max-height: 180px;\n    border-radius: 12px;\n    display: block;\n}\n\n.fb-msg__video--evaluation .fb-msg__eval-label {\n    margin: 0 0 6px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #5c6bc0;\n}\n\n.fb-msg__video--evaluation .fb-msg__eval-caption {\n    margin: 6px 0 0;\n    font-size: 12px;\n    color: #607d8b;\n    line-height: 1.35;\n}\n\n/* Session timeline: group messages by training exercise */\n.fb-chat__group-label {\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 10px 4px 6px;\n    margin: 6px 0 2px;\n}\n\n.fb-chat__group-label__text {\n    font-size: 11px;\n    font-weight: 600;\n    color: #90a4ae;\n    text-align: center;\n}\n\n.fb-chat__group-label__order {\n    font-weight: 500;\n    color: #b0bec5;\n}\n\n.fb-chat__group-label__badge {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--brand-primary);\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n    padding: 3px 8px;\n    border-radius: 999px;\n}\n\n.fb-chat__group-label--current .fb-chat__group-label__text {\n    color: var(--brand-primary);\n}\n\n.fb-msg--current-ex.fb-msg--theirs .fb-msg__bubble {\n    box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n    background: #f3f9ff;\n}\n\n.fb-msg--current-ex.fb-msg--mine .fb-msg__bubble {\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.55);\n}\n\n/* ── Composer (Input Area) ─────────────────────────── */\n.fb-composer {\n    flex-shrink: 0;\n    background: #fff;\n    border-top: 1px solid #eef2f6;\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.fb-composer__input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 13px;\n    font-family: var(--brand-font);\n    padding: 9px 14px;\n    border-radius: 22px;\n    background: #f4f6f8;\n    color: #1a2b3c;\n    transition: background 0.2s;\n}\n\n.fb-composer__input::placeholder {\n    color: #b0bec5;\n}\n\n.fb-composer__input:focus {\n    background: #eceff1;\n}\n\n.fb-composer__actions {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.fb-composer__btn {\n    width: 38px;\n    height: 38px;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    color: #78909c;\n    font-size: 19px;\n}\n\n.fb-composer__btn:hover {\n    background: #f0f4f8;\n    color: var(--brand-primary);\n}\n\n.fb-composer__btn--send {\n    background: var(--brand-primary);\n    color: #fff;\n    width: 40px;\n    height: 40px;\n}\n\n.fb-composer__btn--send:hover {\n    background: var(--brand-primary-dark);\n    color: #fff;\n}\n\n.fb-composer__btn--send svg {\n    font-size: 17px;\n}\n\n.fb-composer__video-label {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    color: #78909c;\n    font-size: 17px;\n}\n\n.fb-composer__video-label:hover {\n    background: #f0f4f8;\n    color: var(--brand-primary);\n}\n\n/* AudioRecorder overrides */\n.fb-composer .audio-recorder {\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    height: 38px !important;\n}\n\n.fb-composer .audio-recorder-mic {\n    color: #78909c !important;\n    transition: color 0.2s !important;\n}\n\n.fb-composer .audio-recorder-mic:hover {\n    color: var(--brand-primary) !important;\n}\n\n/* ================================================================\n   Responsive: Mobile (<640px) – full-screen toggle\n   ================================================================ */\n@media (max-width: 640px) {\n    .fb-page {\n        padding: 6px 6px 0;\n    }\n\n    .fb-body {\n        border-radius: 10px;\n    }\n\n    /* Sidebar fills the whole panel on mobile */\n    .fb-sidebar {\n        width: 100%;\n        border-right: none;\n    }\n\n    /* When a conversation is open, hide sidebar */\n    .fb-body--chat-open .fb-sidebar {\n        display: none;\n    }\n\n    /* When no conversation, hide chat panel */\n    .fb-body:not(.fb-body--chat-open) .fb-conversation {\n        display: none;\n    }\n\n    /* Show back button on mobile */\n    .fb-conv-header__back {\n        display: flex;\n    }\n\n    .fb-exercise-bar {\n        padding: 8px 12px;\n        gap: 10px;\n    }\n\n    .fb-exercise-bar__name {\n        font-size: 13px;\n    }\n\n    .fb-exercise-bar__icon {\n        width: 34px;\n        height: 34px;\n        font-size: 17px;\n    }\n\n    .fb-msg {\n        max-width: 88%;\n    }\n\n    .fb-eval-strip {\n        flex-direction: column;\n        gap: 6px;\n        padding: 8px 10px;\n    }\n}\n\n/* ── Tablet tweaks ─────────────────────────────────── */\n@media (min-width: 641px) and (max-width: 800px) {\n    .fb-sidebar {\n        width: 180px;\n    }\n\n    .fb-player-row__avatar,\n    .fb-player-row__all-icon {\n        width: 32px;\n        height: 32px;\n        font-size: 12px;\n    }\n\n    .fb-player-row__name {\n        font-size: 12px;\n    }\n\n    .fb-player-row {\n        padding: 7px 8px;\n        gap: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
